<template>
  <van-tabbar v-model="active" active-color="#e60000" @change="onChange" fixed>
    <van-tabbar-item replace to="/home">首页</van-tabbar-item>
    <van-tabbar-item replace to="/sign">签到</van-tabbar-item>
    <van-tabbar-item replace to="/release">
      <div class="release">+发布</div>
    </van-tabbar-item>
    <van-tabbar-item replace to="/message">消息</van-tabbar-item>
    <van-tabbar-item replace to="/profile">我</van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  props: {
    active: 0,
  },
  data() {
    return {
      tabActive: this.active,
    };
  },
  methods: {
    onChange(index) {
      this.tabActive = index;
    },
  },
};
</script>

<style scoped>
.release {
  width: 40px;
  height: 40px;
  background-color: var(--color-main);
  border-radius: 20px;
  vertical-align: center;
  color: #fff;
  text-align: center;
  line-height: 40px;
}
</style>
